// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const dic: CountryValidator<"SK"> = createValidator(
  "sk.dic",
  160,
);

export default dic;
export const compact = dic.compact;
export const format = dic.format;
export const validate = dic.validate;
export const generate = (): string =>
  dic.generate?.() ??
  (() => {
    throw new Error(
      "Validator sk.dic cannot generate values",
    );
  })();
